import React from 'react';

export const CheckSubscribe = (props) => {
  return (
    <div className="check registration__check">
      <label className="check__label">
        <input
          autoComplete="off"
          className={props.isOrderTab ? "check__ord" : 'check__inp'}
          type="checkbox"
          name="subscribe"
          required=""
          checked={props.checked}
          onChange={e => props.onChange(e.target.checked)}
        />
        <span className="check__box" />
        <p className="check__text">
          {props.text ? props.text : `Я хочу получать новостные и акционные рассылки Академии`}
        </p>
      </label>
    </div>
  );
};